/* eslint-disable object-shorthand */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/no-unescaped-entities */
import React, { SetStateAction, useCallback, useEffect, useRef, useState } from 'react';
import {
  Backdrop,
  Box,
  Button,
  Chip,
  ClickAwayListener,
  Grid,
  makeStyles,
  MenuItem,
  Modal,
  OutlinedInput,
  Popover,
  Select,
  Tooltip,
} from '@material-ui/core';
import { Add, ArrowDropDown, Cancel, Info, KeyboardArrowDown, Remove } from '@material-ui/icons';
import {
  Breakpoint,
  NewWidgetItemContainer,
  Widget,
  addMetricsToNewWidget,
  addNewItem,
  availableQueueMetrics,
  availableUserMetrics,
  callStateGetter,
  deltaGetter,
  isWidgetValid,
  newItemLayoutRules,
} from './Utilities';
import { WidgetRegistry } from './WidgetRegistry';
import { GridItemHeader, ILayoutValues } from './Widget';
import { MetricObject } from '../QueueWidgetContainer';

interface IAddNewWidgetItem {
  newWidget: Partial<Widget> | undefined;
  setNewWidget: React.Dispatch<SetStateAction<Partial<Widget> | undefined>>;
  styles: Record<string, string>;
  historicalUserList: any;
  historicalQueueList: any;
  setWidgets: React.Dispatch<SetStateAction<Map<string, Widget>>>;
  setLiveDashboardErrorMsg: any;
  accessToken: string;
  lightMode: boolean;
  userDeltas: any;
  queueDeltas: any;
  currentBreakpoint: string;
  liveQueueMetrics: Map<String, MetricObject>
}

const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: 300,
      overflowY: 'auto',
    },
  },
  getContentAnchorEl: null,
  anchorOrigin: {
    vertical: 'bottom',
    horizontal: 'left',
  },
  transformOrigin: {
    vertical: 'top',
    horizontal: 'left',
  },
};

const useStyles = makeStyles(() => ({
  formControl: {
    minWidth: 200,
    marginTop: 12,
  },
  inputRoot: {
    color: 'white',
    borderRadius: 6,
    height: 36,
    '& fieldset': {
      borderColor: 'white',
    },
    '&:hover fieldset': {
      borderColor: '#aaa',
    },
    '&.Mui-focused fieldset': {
      borderColor: '#fff',
    },
  },
  inputLabel: {
    color: 'white',
    '&.Mui-focused': {
      color: 'white',
    },
  },
  menuPaper: {
    backgroundColor: '#2c2c2c',
    color: 'white',
  },
  listSubheader: {
    backgroundColor: '#2c2c2c',
    color: 'white',
    fontWeight: 500,
    fontSize: '0.85rem',
  },
  select: {
    minWidth: '25%',
    color: 'white',
    background: '#3b3b3b',
    '& .MuiSelect-icon': {
      color: 'white', // white arrow
    },
    '&:before': {
      borderBottom: '1px solid #aaa', // default
    },
    '&:after': {
      borderBottom: '1px solid white', // focus
    },
    '&:hover:not(.Mui-disabled):before': {
      borderBottom: '1px solid white', // hover
    },
  },
  chip: {
    background: 'linear-gradient(0deg, #5b5c65, #505055)',
    margin: 2,
    color: '#aaa',
    // "&:hover": {
    // background: "linear-gradient(0deg, #4a4b53, #505055)"
    // }
  },
  selectMultiple: {
    minWidth: 300,
    marginLeft: 20,
    color: 'white',
    paddingLeft: 10,
    paddingRight: 10,
    borderRadius: 5,
    minheight: 60,
    background: '#3b3b3b',
    '& .MuiSelect-icon': {
      color: 'white', // white arrow
    },
    '&:before': {
      borderBottom: '1px solid white', // default
    },
    '&:after': {
      borderBottom: '1px solid white', // focus
    },
    '&:hover:not(.Mui-disabled):before': {
      borderBottom: '1px solid white', // hover
    },
  },
}));

function AddNewWidgetItem({
  lightMode,
  accessToken,
  setLiveDashboardErrorMsg,
  newWidget,
  setNewWidget,
  styles,
  setWidgets,
  historicalUserList,
  historicalQueueList,
  userDeltas,
  currentBreakpoint,
  queueDeltas,
  liveQueueMetrics
}: IAddNewWidgetItem) {
  const [metricAnchorEl, setMetricAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [metricValuesAnchorEl, setMetricValuesAnchorEl] = useState<HTMLButtonElement | null>(null);
  const [popoverWidth, setPopoverWidth] = useState<number>(1);

  const handleMetricPopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMetricAnchorEl(event.currentTarget);
  };
  const handleMetricValuePopover = (event: React.MouseEvent<HTMLButtonElement>) => {
    setMetricValuesAnchorEl(event.currentTarget);
  };

  useEffect(() => {
    if (metricAnchorEl) {
      setPopoverWidth(metricAnchorEl.getBoundingClientRect().width);
    }
  }, [metricAnchorEl]);

  const changeNewWidgetValues = useCallback((key: keyof Widget, value: any, clearedValues?: (keyof Widget)[]) => {
    const formattedVal = value === '--' ? undefined : value;

    setNewWidget((prev: any) => {
      const updates: Partial<Widget> = { [key]: formattedVal };

      if (Array.isArray(clearedValues) && clearedValues.length > 0) {
        clearedValues.forEach((field) => {
          updates[field] = undefined;
        });
      }
      return { ...prev, ...updates };
    });
  }, []);


  

  return (
    <Modal open={!!newWidget} onClose={() => setNewWidget(undefined)}>
      {/* LEFT SIDE */}
      <Box className={styles.modalBox}>
        <Grid container className={styles.modalBoxContainer}>
          <Grid item xs={6} className={styles.modalBoxLeft}>
            <h1 className={styles.header}>Create New Widget</h1>
            <div className={styles.modalContainer}>
              <NewWidgetItemContainer title="Topic" styles={styles} width={1}>
                <select
                  className={styles.selectMultiple}
                  value={newWidget?.category}
                  defaultValue={newWidget?.category}
                  onChange={(e) =>
                    changeNewWidgetValues('category', e.target.value, ['key', 'metrics', 'metricValues'])
                  }
                >
                  <option value="--">-</option>
                  {WidgetRegistry.getWidgetCategories().map((widget) => (
                    <option value={widget}>{widget}</option>
                  ))}
                </select>
              </NewWidgetItemContainer>
              <NewWidgetItemContainer title="Widget" styles={styles} width={1}>
                <select
                  className={styles.selectMultiple}
                  defaultValue={newWidget?.key}
                  value={newWidget?.key}
                  onChange={(e) => changeNewWidgetValues('key', e.target.value)}
                >
                  <option value="--">-</option>
                  {newWidget?.category &&
                    WidgetRegistry.getWidgets(newWidget?.category).map((widget) => (
                      <option value={widget?.key || ''}>{widget.label}</option>
                    ))}
                </select>
              </NewWidgetItemContainer>
              {newWidget?.key && (
                <NewWidgetItemContainer title="Description" styles={styles} width={2}>
                  <div className={styles.aboutContainer}>
                    <Info fontSize="small" /> {WidgetRegistry.getDescription(newWidget || {})}
                  </div>
                </NewWidgetItemContainer>
              )}
              {/* ONLY Customized & KPI widgets will have metric and metricValus options. */}
              {newWidget && (newWidget?.key === 'customized' || newWidget?.key === 'kpi') && (
                <NewWidgetItemContainer styles={styles} title="Dimension" width={1}>
                  <select
                    className={styles.selectMultiple}
                    value={newWidget?.dimensionType ?? '--'}
                    onChange={(e) =>
                      changeNewWidgetValues('dimensionType', e.target.value, ['metrics', 'metricValues'])
                    }
                  >
                    <option value="--">--</option>
                    <option value="users">Users</option>
                    <option value="queues">Queues</option>
                  </select>
                </NewWidgetItemContainer>
              )}
              {(newWidget?.dimensionType === 'users' || newWidget?.dimensionType === 'queues') && (
                <>
                  {(() => {
                    let availableMetrics: any;
                    let historicalList: any;
                    if (newWidget.dimensionType === 'queues') {
                      availableMetrics = availableQueueMetrics;
                      historicalList = historicalQueueList;
                    }
                    if (newWidget.dimensionType === 'users') {
                      availableMetrics = availableUserMetrics;
                      historicalList = historicalUserList;
                    }
                    return (
                      <>
                        {/* Metrics Select */}
                        {newWidget.widgetType !== 'quick' && (
                          <NewWidgetItemContainer styles={styles} title="Metric">
                            <ClickAwayListener onClickAway={() => setMetricAnchorEl(null)}>
                              <div>
                                <button type="button" className={ metricAnchorEl ? [styles.selectMultipleFocus, styles.selectMultiple].join(' ') : styles.selectMultiple} onClick={handleMetricPopover} id="select-metric">
                                  {newWidget?.metrics ?.map( (metric) => availableMetrics.find((availableMetric: any) => availableMetric.key === metric) ?.label, ) .join(', ')}
                                  <KeyboardArrowDown fontSize="small" className={styles.selectChevron} />
                                  {/* <RenderChipItems metrics={newWidget.metrics} setNewWidget={setNewWidget} property="metrics" /> */}
                                </button>
                                <Popover PaperProps={{ style: popoverWidth ? { width: popoverWidth } : undefined }} open={!!metricAnchorEl} anchorEl={metricAnchorEl} onClose={() => setMetricAnchorEl(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }}>
                                  <div className={styles.optionDropdown}>
                                    {availableMetrics
                                      ?.filter((metric: any) => {
                                        if (
                                          newWidget?.metrics?.some(
                                            (newWidgetMetric) =>
                                              newWidgetMetric?.toLowerCase()?.includes('duration') ||
                                              newWidgetMetric?.toLowerCase()?.includes('time'),
                                          )
                                        ) {
                                          return (
                                            metric.key.toLowerCase()?.includes('duration') ||
                                            metric?.key?.toLowerCase()?.includes('time')
                                          );
                                        }
                                        if (
                                          newWidget?.metrics?.some((newWidgetMetric) =>
                                            newWidgetMetric?.toLowerCase()?.includes('count'),
                                          )
                                        ) {
                                          return metric.key.toLowerCase()?.includes('count');
                                        }
                                        return metric;
                                      })
                                      .map(({ key, label }: any) => (
                                        <div className={styles.dropdownOption} key={key}>
                                          <button type="button" value={key} id={key} className={
                                              newWidget?.metrics?.find((metric: any) => metric === key)
                                                ? [styles.dropdownButton, styles.dropdownButtonSelected].join(' ')
                                                : styles.dropdownButton} onClick={(e) => {
                                              // e.stopPropagation();
                                              addMetricsToNewWidget( e.currentTarget.value, newWidget, setNewWidget, 'metrics',); }}>
                                            <label htmlFor={key}>{label}</label>
                                          </button>
                                          {/* <input checked={!!newWidget?.metrics?.find((metric: any) => metric === key)}  type="checkbox" id={key} value={key} /> */}
                                        </div>
                                      ))}
                                  </div>
                                </Popover>
                              </div>
                            </ClickAwayListener>
                          </NewWidgetItemContainer>
                        )}
                        {/* Metric Vlaues */}
                        {historicalList && newWidget.widgetType !== 'kpi' && newWidget.widgetType !== 'quick' && (
                          <NewWidgetItemContainer styles={styles} title="Metric Values" width={2}>
                            <Grid container spacing={2}>
                              <Grid item xs={6}>
                                <ClickAwayListener onClickAway={() => setMetricValuesAnchorEl(null)}>
                                  <div>
                                    <button
                                      type="button"
                                      className={
                                        metricValuesAnchorEl
                                          ? [styles.selectMultipleFocus, styles.selectMultiple].join(' ')
                                          : styles.selectMultiple
                                      }
                                      onClick={handleMetricValuePopover}
                                      id="select-metric-values"
                                    >
                                      {newWidget?.metricValues &&
                                        newWidget?.metricValues
                                          ?.map(
                                            (metricValue) =>
                                              historicalList?.find((historical: any) => historical?.id === metricValue)
                                                ?.name,
                                          )
                                          ?.join(', ')}
                                      <KeyboardArrowDown fontSize="small" className={styles.selectChevron} />
                                      {/* <RenderChipItems metrics={newWidget.metrics} setNewWidget={setNewWidget} property="metrics" /> */}
                                    </button>
                                    <Popover PaperProps={{ style: popoverWidth ? { width: popoverWidth } : undefined }} open={!!metricValuesAnchorEl} anchorEl={metricValuesAnchorEl} onClose={() => setMetricValuesAnchorEl(null)} anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }} transformOrigin={{ vertical: 'top', horizontal: 'left' }}
                                    >
                                      <div className={styles.optionDropdown}>
                                        {historicalList?.map((listItem: any) => (
                                          <div className={styles.dropdownOption} key={listItem?.id}>
                                            <button
                                              type="button"
                                              value={listItem.id}
                                              id={listItem.id}
                                              className={
                                                newWidget?.metricValues?.find((metric: any) => metric === listItem.id)
                                                  ? [styles.dropdownButton, styles.dropdownButtonSelected].join(' ')
                                                  : styles.dropdownButton
                                              }
                                              onClick={(e) => {
                                                // e.stopPropagation();
                                                addMetricsToNewWidget(
                                                  e.currentTarget.value,
                                                  newWidget,
                                                  setNewWidget,
                                                  'metricValues',
                                                );
                                              }}
                                            >
                                              {/* <input checked={!!newWidget?.metricValues?.find((metric: any) => metric === listItem.id)}  type="checkbox" id={listItem.id} value={listItem.id} /> */}
                                              <label htmlFor={listItem?.id}>{listItem?.name}</label>
                                            </button>
                                          </div>
                                        ))}
                                      </div>
                                    </Popover>
                                  </div>
                                </ClickAwayListener>
                              </Grid>
                              <Grid item xs={6}>
                                <div style={{ display: 'flex', alignItems: 'center', gap: 10, margin: 10 }}>
                                  <Button style={{ minWidth: '50%' }} size="small" variant="contained" startIcon={<Add />} onClick={() =>
                                      setNewWidget((prev) => ({
                                        ...prev,
                                        metricValues: historicalList.map(({ id }: { id: string }) => id),
                                      }))}>All</Button>
                                  <Button style={{ minWidth: '50%' }} size="small" variant="contained" startIcon={<Remove />} onClick={() =>
                                      setNewWidget((prev) => ({
                                        ...prev,
                                        metricValues: [],
                                      }))}
                                  >All</Button>
                                </div>
                              </Grid>
                            </Grid>
                          </NewWidgetItemContainer>
                        )}
                      </>
                    );
                  })()}
                </>
              )}
              {newWidget &&
                newWidget?.metrics &&
                newWidget.widgetType !== 'kpi' &&
                newWidget.widgetType !== 'quick' && (
                  <NewWidgetItemContainer title="Visual Type" styles={styles}>
                    <select
                      className={styles.selectMultiple}
                      defaultValue={newWidget?.visualType ?? undefined}
                      onChange={(e) =>
                        setNewWidget(
                          (prev) =>
                            ({
                              ...prev,
                              visualType: e.target.value === '--' ? undefined : e.target.value,
                            } as Partial<Widget>),
                        )
                      }
                    >
                      <option value="--">--</option>
                      <option value="donut">Donut</option>
                      <option value="pie">Pie</option>
                      <option value="bar">Bar</option>
                    </select>
                  </NewWidgetItemContainer>
                )}
            </div>
             
            {newWidget?.key && ( // TEXT & BG COLOR
              <>
                <NewWidgetItemContainer title="Text Color" styles={styles}>
                  <input
                    type="color"
                    className={styles.selectMultiple}
                    value={newWidget?.cosmetics?.color ?? '#000000'}
                    onChange={(e) =>
                      setNewWidget((prev) => ({
                        ...prev,
                        cosmetics: {
                          ...prev?.cosmetics,
                          color: e.target.value,
                        },
                      }))
                    }
                    style={{ paddingRight: 0 }}
                  />
                  <button
                    type="button"
                    onClick={() =>
                      setNewWidget((prev) => ({
                        ...prev,
                        cosmetics: {
                          ...prev?.cosmetics,
                          color: '#000000',
                        },
                      }))
                    }
                  >
                    clear
                  </button>
                </NewWidgetItemContainer>

                <NewWidgetItemContainer title="Background Color" styles={styles}>
                  <input type="color" className={styles.selectMultiple} value={newWidget?.cosmetics?.bgColor ?? '#ffffff'} onChange={(e) =>
                      setNewWidget((prev) => ({ ...prev, cosmetics: { ...prev?.cosmetics, bgColor: e.target.value, }, })) } style={{ paddingRight: 0 }} />
                  <button type="button" onClick={() => setNewWidget((prev) => ({
                        ...prev,
                        cosmetics: { ...prev?.cosmetics, bgColor: undefined}}))}>
                          clear
                  </button>
                </NewWidgetItemContainer>
              </>
            )}
            {
              // newWidget && newWidget?.widgetType !== "quick" &&
              newWidget?.key && ( // title
                <NewWidgetItemContainer title="Title" styles={styles}>
                  <input type="text"defaultValue={newWidget?.label} className={styles.selectMultiple}placeholder={newWidget?.label || "Title"} onChange={(e) => setNewWidget((prev) => ({ ...prev, title: e.target.value.length === 0 ? newWidget?.label : e.target.value, }))}style={{ paddingRight: 0 }}/>
                </NewWidgetItemContainer>
              )
            }
            {newWidget && (
              <NewWidgetItemContainer title="" styles={styles}>
                <button disabled={!WidgetRegistry.getConfirmationRequirements(newWidget)} className={styles.confirmButton} type="button" onClick={() => addNewItem(setWidgets, newWidget as Widget, setNewWidget, setLiveDashboardErrorMsg)} >
                  Confirm
                </button>
              </NewWidgetItemContainer>
            )}
          </Grid>

          {/* RiGHT SIDE */}
          <Grid item xs={6} className={styles.modalBoxRight}>
             <div className={styles.gridItemContainer}
                style={{background: newWidget?.cosmetics?.bgColor ? 
                  `linear-gradient(337deg, ${newWidget.cosmetics?.bgColor}${lightMode ? "ee" : "aa"}, ${newWidget?.cosmetics?.bgColor}${lightMode ? "7d" : "aa"})`
                    : "",
                    // height: "100%",
                    height: 290,
                    width: 290,
                    // width: "50%"
                }}>
                <GridItemHeader
                  accessToken={accessToken} widgetContent={newWidget as Widget}
                  styles={styles} quickEditMode={false}
                  layout={{ i: "", x: 0, y: 99, w: 6, h: 6}} editWidget={() => undefined} setWidgets={setWidgets}
                  widgets={new Map()} setLiveDashboardErrorMsg={setLiveDashboardErrorMsg}
                />
                  {WidgetRegistry.renderWidget(newWidget?.key || 'example', {
                    styles: styles,
                    layout:{ i: "", x: 0, y: 99, w: 6, h: 6},
                    historicalUsers: historicalUserList,
                    historicalQueues: historicalQueueList,
                    accessToken: accessToken,
                    lightMode: lightMode,
                    liveQueueMetrics: liveQueueMetrics,
                    queueDeltas: queueDeltas,
                    userDeltas: userDeltas,
                    widgetId: newWidget?.widgetId || '',

                    widgetContent: newWidget,

                    // will need to remove this
                    queueCallStates: callStateGetter(newWidget as Widget, userDeltas, queueDeltas),
                    // will need to remove this
                    deltas: deltaGetter(newWidget as Widget, userDeltas, queueDeltas)
                  })}
                </div>
          
          </Grid>
        </Grid>
      </Box>
    </Modal>
  );
}

export default AddNewWidgetItem;
